export default __webpack_public_path__ + "static/media/osteoplus.0b95864d.png";